(function () {
  function customRender(product) {
    const { title, featuredMedia, variants, id, handle, vendor } = product;
    const image = featuredMedia?.preview?.image?.url || '';

    return `
    <li class="wishlist__grid-item" id="${id}">
      <button type="button" class="abrwl-button abrwl-button--remove desktop" abrwl-button data-product-id="${id}">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1.3332 11.5449L0.455078 10.6668L5.12174 6.00011L0.455078 1.33345L1.3332 0.455322L5.99987 5.12199L10.6665 0.455322L11.5447 1.33345L6.878 6.00011L11.5447 10.6668L10.6665 11.5449L5.99987 6.87824L1.3332 11.5449Z" fill="currentColor"/>
        </svg>
      </button>
      <div class="wishlist__image-wrapper">
        <img width="auto" height="auto" src="${image}&width=400" alt="${title}">
      </div>
      <div class="wishlist__product-info">
        <div class="wishlist__product-info-top-container">
          <div class="wishlist__product-info-title-container">
            ${vendor ? `<p class="card__vendor p-sh">${vendor}</p>` : ""}
            <h3 class="wishlist__product-heading p-s">
              <a href="/products/${handle}" class="full-unstyled-link">${title}</a>
            </h3>
          </div>
          <div class="wishlist__product-info-price-container">
            <div class="price">${variants?.nodes?.[0]?.price} €</div>
          </div>
        </div>
        <div class="card-information">
          <button type="button" class="quick-add quick-add__submit button button--primary-black left small abrwl-add-to-cart" data-variant-id="${variants?.nodes?.[0]?.id || ''}" data-product-handle="${handle}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="path" d="M3.74363 13.3333C3.44529 13.3333 3.19118 13.2284 2.98129 13.0186C2.77151 12.8087 2.66663 12.5546 2.66663 12.2563V5.07692C2.66663 4.77859 2.77151 4.52447 2.98129 4.31459C3.19118 4.10481 3.44529 3.99992 3.74363 3.99992H5.33329C5.33329 3.25714 5.59207 2.62703 6.10963 2.10959C6.62707 1.59203 7.25718 1.33325 7.99996 1.33325C8.74274 1.33325 9.37285 1.59203 9.89029 2.10959C10.4078 2.62703 10.6666 3.25714 10.6666 3.99992H12.2563C12.5546 3.99992 12.8087 4.10481 13.0186 4.31459C13.2284 4.52447 13.3333 4.77859 13.3333 5.07692V12.2563C13.3333 12.5546 13.2284 12.8087 13.0186 13.0186C12.8087 13.2284 12.5546 13.3333 12.2563 13.3333H3.74363ZM3.74363 12.6666H12.2563C12.359 12.6666 12.453 12.6239 12.5385 12.5384C12.6239 12.453 12.6666 12.3589 12.6666 12.2563V5.07692C12.6666 4.97425 12.6239 4.8802 12.5385 4.79475C12.453 4.70931 12.359 4.66659 12.2563 4.66659H3.74363C3.64096 4.66659 3.5469 4.70931 3.46146 4.79475C3.37601 4.8802 3.33329 4.97425 3.33329 5.07692V12.2563C3.33329 12.3589 3.37601 12.453 3.46146 12.5384C3.5469 12.6239 3.64096 12.6666 3.74363 12.6666ZM7.99996 7.99992C8.74274 7.99992 9.37285 7.74114 9.89029 7.22359C10.4078 6.70614 10.6666 6.07603 10.6666 5.33325H9.99996C9.99996 5.88881 9.80551 6.36103 9.41663 6.74992C9.02774 7.13881 8.55551 7.33325 7.99996 7.33325C7.4444 7.33325 6.97218 7.13881 6.58329 6.74992C6.1944 6.36103 5.99996 5.88881 5.99996 5.33325H5.33329C5.33329 6.07603 5.59207 6.70614 6.10963 7.22359C6.62707 7.74114 7.25718 7.99992 7.99996 7.99992ZM5.99996 3.99992H9.99996C9.99996 3.44436 9.80551 2.97214 9.41663 2.58325C9.02774 2.19436 8.55551 1.99992 7.99996 1.99992C7.4444 1.99992 6.97218 2.19436 6.58329 2.58325C6.1944 2.97214 5.99996 3.44436 5.99996 3.99992Z" fill="white"/>
            </svg>
            Hinzufügen
          </button>
          <button type="button" class="abrwl-button abrwl-button--remove mobile" abrwl-button data-product-id="${id}">
            <span class="svg-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16">
                <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/>
                <path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </li>`;
  }
  window.abrwl = window.abrwl || {};
  window.abrwl.config = {
    renderProductCard: customRender,
    fields: ['vendor'],
  };

  // Extract numeric variant ID from GID format if needed
  function extractVariantId(gid) {
    if (!gid) return null;
    // If it's already a numeric string, return it
    if (/^\d+$/.test(gid)) return gid;
    // If it's a GID format, extract the numeric part
    const match = gid.match(/\/(\d+)$/);
    return match ? match[1] : gid;
  }

  // Handle add to cart functionality
  function handleAddToCart() {
    document.addEventListener('click', function(e) {
      const addToCartButton = e.target.closest('.abrwl-add-to-cart');
      if (!addToCartButton) return;

      e.preventDefault();
      const variantIdGid = addToCartButton.dataset.variantId;
      if (!variantIdGid) {
        console.error('Variant ID not found');
        return;
      }
      
      const variantId = extractVariantId(variantIdGid);
      if (!variantId) {
        console.error('Invalid variant ID format');
        return;
      }

      // Disable button during request
      addToCartButton.disabled = true;
      const originalText = addToCartButton.innerHTML;
      addToCartButton.innerHTML = '<span>Wird hinzugefügt...</span>';

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({id: variantId, quantity: 1}),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(async () => {
          // Fetch updated drawer HTML
          const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          const data = await res.json();

          // Replace the entire drawer element
          const oldDrawer = document.querySelector('cart-drawer');
          oldDrawer.outerHTML = data['cart-drawer'];

          // Re-select the newly injected drawer
          const newDrawer = document.querySelector('cart-drawer');

          // Open it
          newDrawer.open();

          // Update cart bubble
          document.getElementById('cart-icon-bubble').innerHTML = data['cart-icon-bubble'];
        })
        .catch((err) => {
          console.error("Error adding to cart:", err);
          alert(err.description || 'Fehler beim Hinzufügen zum Warenkorb');
        })
        .finally(() => {
          addToCartButton.innerHTML = originalText;
          addToCartButton.disabled = false;
        });
    });
  }

  // Initialize add to cart handler when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleAddToCart);
  } else {
    handleAddToCart();
  }
})();
